
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="pt-24 sm:pt-28 md:pt-32 pb-12 sm:pb-16 md:pb-20 px-4 sm:px-6 bg-gradient-to-b from-sub/40 to-white">
      <div className="max-w-7xl mx-auto text-center">
        <div className="inline-block bg-white px-4 py-1 rounded-full mb-4 sm:mb-6 shadow-sm">
          <span className="text-primary text-xs font-medium tracking-wider uppercase">Blog & News</span>
        </div>
        <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-primary mb-4 sm:mb-6 px-4">
          ブログ&新着情報
        </h1>
        <p className="text-gray-600 text-sm sm:text-base mb-6 sm:mb-8 max-w-2xl mx-auto px-4">
          <strong>岡山市の鍼灸院</strong>から、健康に役立つ情報や院内のお知らせをお届けします
        </p>
        <nav className="flex items-center justify-center gap-2 text-xs sm:text-sm text-gray-600">
          <Link to="/" className="hover:text-primary transition-colors">トップ</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-primary font-medium">ブログ&新着情報</span>
        </nav>
      </div>
    </section>
  );
};

export default HeroSection;
